export const EXPENDITURE_CF_NAME = 'Expenditure Category - Voly';
export const COST_CENTRE_CF_NAME = 'Cost Centre - Voly';
export const NET_CF_NAME = 'Invoice Net - Voly';
export const VAT_CF_NAME = 'Invoice VAT - Voly';
export const TOTAL_CF_NAME = 'Invoice Total - Voly';
